import Player from '@vimeo/player/dist/player';

export class WebinarWatcher {
    constructor(iframe, webinarId = null, webinarWatchedTime = null, webinarEnded = null, webinarType = '') {
        if (iframe instanceof HTMLIFrameElement) {
            this.player = new Player(iframe);
            this.timeWatched = webinarWatchedTime !== null ? webinarWatchedTime : parseInt(iframe.dataset.webinarWatchedTime);
            this.watchedInPercentage = 0.0;
            this.lastSavedTime = 0.0;
            this.sleepTillNextSave = 30;
            this.webinarId = webinarId !== null ? webinarId : iframe.dataset.webinarId;
            this.webinarEnded = webinarEnded !== null ? webinarEnded : iframe.dataset.webinarEnded === '1';
            this.webinarType = webinarType !== '' ? webinarType : iframe.dataset.webinarType;
            this.saveRequestLocked = false;

            this.initializeEvents();
        }
    }

    initializeEvents() {
        this.player.ready().then(() => {
            // console.log('Player is ready');
        }).catch((error) => {
            console.error(error);
            // on error enabled quiz by default
            // e.g. video is not playable because of its privacy settings
        });
        this.player.on('timeupdate', (data) => {
            this.updateProperties(data);
            if (this.isSaveTimeWatchedNecessary(data.seconds)) {
                this.saveTimeWatched(this.webinarId, false);
            }
        });
        this.player.on('ended', (data) => {
            this.updateProperties(data);
            if (this.webinarEnded === false) {
                this.saveTimeWatched(this.webinarId, true);
            }
        });
        this.player.on('seeked', (data) => {
            this.disableSeeking(data.seconds);
        });
    }

    updateProperties(data) {
        if (data.seconds - 1 < this.timeWatched && data.seconds > this.timeWatched) {
            this.timeWatched = data.seconds;
            this.watchedInPercentage = data.percent * 100;
        }
    }

    isSaveTimeWatchedNecessary(seconds) {
        return this.webinarEnded === false
            && seconds <= this.timeWatched
            && seconds >= this.lastSavedTime + this.sleepTillNextSave;
    }

    saveTimeWatched(webinar, isEnded) {
        if (this.saveRequestLocked === false) {
            this.saveRequestLocked = true;

            fetch('/en/webinar-watcher/save/', {
                method: 'POST',
                body: JSON.stringify({
                    webinar: webinar,
                    time: this.timeWatched,
                    percent: isEnded ? 100 : this.watchedInPercentage,
                    type: this.webinarType
                }),
                headers: {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then((response) => response.json())
            .then((json) => {
                // console.log(json);
            }).catch((error) => {
                console.error(error);
            }).finally(() => {
                this.saveRequestLocked = false;
                this.lastSavedTime = this.timeWatched;
                if (isEnded) {
                    this.webinarEnded = true;
                }
            });
        }
    }

    disableSeeking(seconds) {
        if (this.timeWatched < seconds) {
            this.player.setCurrentTime(this.timeWatched);
        }
    }
}
